import React from "react";
import PropTypes from "prop-types";
import { Grid, TextField, IconButton, Button, Stack, Typography, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import { searchBoxStyles } from "utils/pageHeaderStyles";

const KategoriKutipanSearch = ({
  search,
  handleSearchChange,
  onTambah,
  onDelete,
  selectedRow,
}) => {
  const [controller] = useMaterialUIController();
  const { darkMode, whiteSidenav, transparentSidenav } = controller;
  const shouldApplyStyle =
    (!darkMode && !whiteSidenav && !transparentSidenav) ||
    (darkMode && !transparentSidenav && whiteSidenav);

  return (
    <MDBox sx={searchBoxStyles.container}>
      <Typography variant="h6" fontWeight="bold" mb={1.5}>
        Senarai Kategori Kutipan
      </Typography>
      <Box xs={12} md={2.5}>
        <TextField
          label="Kategori Kutipan"
          name="kategori_kutipan"
          size="small"
          value={search.kategori_kutipan || ""}
          onChange={handleSearchChange}
          InputProps={{
            endAdornment: (
              <IconButton size="small">
                <SearchIcon fontSize="small" />
              </IconButton>
            ),
          }}
          fullWidth
        />
      </Box>
      <Button
        sx={{ fontSize: { xs: 10, sm: 10, md: 10, lg: 10 } }}
        variant="text"
        color="success"
        startIcon={<AddCircleIcon />}
        size="small"
        onClick={onTambah}
      >
        Tambah Kategori
      </Button>
      <Button
        sx={{ fontSize: { xs: 10, sm: 10, md: 10, lg: 10 } }}
        variant="text"
        color="error"
        startIcon={<DeleteIcon />}
        size="small"
        onClick={onDelete}
        disabled={!selectedRow}
      >
        Hapus Kategori
      </Button>
    </MDBox>
  );
};

KategoriKutipanSearch.propTypes = {
  search: PropTypes.shape({
    kategori_kutipan: PropTypes.string,
  }).isRequired,
  handleSearchChange: PropTypes.func.isRequired,
  onTambah: PropTypes.func,
  onDelete: PropTypes.func,
  selectedRow: PropTypes.object,
};

KategoriKutipanSearch.defaultProps = {
  onTambah: () => {},
  onDelete: () => {},
  selectedRow: null,
};

export default KategoriKutipanSearch;
